import * as React from 'react';
import { gql } from '@apollo/client';
import {
  RemoveTeamMemberModalController,
  RemoveTeamMemberModalControllerProps
} from './RemoveTeamMemberModal.controller';
import { useDeleteInvitedMemberMutation, useRemoveUserOrganizationAssignmentMutation } from '../../../models/graphql';

export type RemoveTeamMemberModalApolloProps = Omit<
  RemoveTeamMemberModalControllerProps,
  'deleteUserInvitation' | 'removeUserOrgAssignment'
> & {
  // ...
};

gql`
  mutation DeleteInvitedMember($userInvitationId: ID!) {
    deleteUserInvitation(userInvitationId: $userInvitationId)
  }

  mutation RemoveUserOrganizationAssignment($organizationId: ID!, $userId: ID!) {
    removeUserOrganizationAssignment(organizationId: $organizationId, userId: $userId)
  }
`;

export const RemoveTeamMemberModalApollo = (props: RemoveTeamMemberModalApolloProps): JSX.Element => {
  const [deleteUserInvitation] = useDeleteInvitedMemberMutation();

  const [removeUserOrgAssignment] = useRemoveUserOrganizationAssignmentMutation();

  const controllerProps: RemoveTeamMemberModalControllerProps = {
    ...props,
    deleteUserInvitation,
    removeUserOrgAssignment
  };

  return <RemoveTeamMemberModalController {...controllerProps} />;
};
